import axiosInstance from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/config';
import type { Reminder, ReminderPayload, ReminderChoices } from './reminderService';

export type Task = Reminder;
export type TaskPayload = Omit<ReminderPayload, 'category'>;

const taskService = {
  // Tasks are self-only — no dependant scoping.
  async getTasks(opts?: { is_completed?: boolean }): Promise<Task[]> {
    const params: any = {};
    if (opts?.is_completed != null) params.is_completed = opts.is_completed;
    const response = await axiosInstance.get(API_ENDPOINTS.tasks.list, { params });
    const d = response.data;
    return Array.isArray(d) ? d : d.results || [];
  },

  async getTask(id: number): Promise<Task> {
    const response = await axiosInstance.get(`${API_ENDPOINTS.tasks.list}${id}/`);
    return response.data;
  },

  async createTask(data: TaskPayload): Promise<Task> {
    const response = await axiosInstance.post(API_ENDPOINTS.tasks.list, data);
    return response.data;
  },

  async updateTask(id: number, data: TaskPayload): Promise<Task> {
    const response = await axiosInstance.put(`${API_ENDPOINTS.tasks.list}${id}/`, data);
    return response.data;
  },

  async deleteTask(id: number): Promise<void> {
    await axiosInstance.delete(`${API_ENDPOINTS.tasks.list}${id}/`);
  },

  async markComplete(id: number): Promise<Task> {
    const response = await axiosInstance.post(`${API_ENDPOINTS.tasks.list}${id}/mark-complete/`);
    return response.data;
  },

  async getUpcoming(): Promise<Task[]> {
    const response = await axiosInstance.get(API_ENDPOINTS.tasks.upcoming);
    const d = response.data;
    return Array.isArray(d) ? d : d.results || [];
  },

  async getChoices(): Promise<ReminderChoices> {
    const response = await axiosInstance.get(API_ENDPOINTS.tasks.choices);
    return response.data;
  },

  // ─── Subtask endpoints ─────────────────────────────────────────────

  async addSubtask(taskId: number, title: string): Promise<Task> {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.tasks.list}${taskId}/subtasks/`,
      { title }
    );
    return response.data;
  },

  async toggleSubtask(taskId: number, subtaskId: number): Promise<Task> {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.tasks.list}${taskId}/subtasks/${subtaskId}/toggle/`
    );
    return response.data;
  },

  async deleteSubtask(taskId: number, subtaskId: number): Promise<Task> {
    const response = await axiosInstance.delete(
      `${API_ENDPOINTS.tasks.list}${taskId}/subtasks/${subtaskId}/`
    );
    return response.data;
  },
};

export default taskService;
